import {emailCampaignService} from '../services'

const state = {
    loading: false,
}

const actions = {

    add({ dispatch, commit }, params) {
        commit('startRequest')
        return emailCampaignService.add(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Campaign created successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to create campaign: ' + error, { root: true })
            }
        )
    },

    update({ dispatch, commit }, params) {
        commit('startRequest')
        return emailCampaignService.update(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Campaign updated successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to update campaign: ' + error, { root: true })
            }
        )
    },

    remove({ dispatch, commit }, id) {
        commit('startRequest')
        return emailCampaignService.remove(id).then(
            response => {
                commit('endRequest')
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to remove campaign: ' + error, { root: true })
            }
        )
    },

    membersCount({ dispatch, commit }, params) {
        commit('startRequest')
        return emailCampaignService.membersCount(params).then(
            response => {
                commit('endRequest')
                return response
            },
            error => {
                commit('endRequest')
            }
        )
    },


}

const mutations = {
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    }
}


export const emailCampaignModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
